/* eslint-disable no-unused-vars */
/* eslint-disable consistent-return */
/* eslint-disable import/no-unresolved */
/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { Image } from 'react-bootstrap'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/effect-creative'
import { EffectCube } from 'swiper/modules'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/free-solid-svg-icons'
import { mobilePhone, wavenet_logo } from '../asset'
import CIIcon from './CIIcon'

function RotateCubeStickyPreview({ srcs }) {
  const [imageUrls, setImageUrls] = useState([])
  const swiperRef = useRef(null)
  const containerRef = useRef(null)
  // const [lastScrollY, setLastScrollY] = useState(0)
  const [swiperHeight, setSwiperHeight] = useState('auto')
  const [isSwiperFinished, setIsSwiperFinished] = useState(false)

  useEffect(() => {
    if (!srcs || !Array.isArray(srcs) || srcs.length === 0) {
      setImageUrls([])
      return
    }

    const urls = srcs
      .filter((img) => img.file)
      .map((img) =>
        img.file instanceof File || img.file instanceof Blob
          ? URL.createObjectURL(img.file)
          : img.file
      )

    setImageUrls(urls)

    return () => {
      // urls.forEach((url) => URL.revokeObjectURL(url))
    }
  }, [srcs])

  useEffect(() => {
    const updateSwiperHeight = () => {
      if (swiperRef.current && swiperRef.current.el) {
        const height = swiperRef.current.el.offsetHeight
        setSwiperHeight(`${height}px`)
      }
    }

    updateSwiperHeight()
    window.addEventListener('resize', updateSwiperHeight)

    return () => {
      window.removeEventListener('resize', updateSwiperHeight)
    }
  }, [imageUrls])

  useEffect(() => {
    if (!swiperRef.current) return

    const swiperInstance = swiperRef.current.swiper

    swiperInstance.on('slideChange', () => {
      if (swiperInstance.activeIndex === swiperInstance.slides.length - 1) {
        setIsSwiperFinished(true)
      }
    })
  }, [])

  const handleWheel = (e) => {
    if (swiperRef.current) {
      if (e.deltaY > 0) {
        swiperRef.current.swiper.slideNext()
      } else {
        swiperRef.current.swiper.slidePrev()
      }
    }
  }

  return (
    <div
      ref={containerRef}
      className="scroller-hide"
      style={{ maxHeight: '57.5vh', overflow: 'auto' }}
      onWheel={handleWheel}
    >
      {/* 頂部內容 */}
      <div className="w-100 pb-1">
        <Image
          className="position-absolute"
          src={mobilePhone}
          style={{ width: '19.5rem', right: '16%', top: '6%' }}
        />
      </div>
      <div style={{ position: 'relative' }}>
        <div
          className="border-bottom mb-3 d-flex"
          style={{ width: '240px', height: '55px', zIndex: '0' }}
        >
          <div className="w-80 m-auto ms-auto">
            <Image src={wavenet_logo} className="w-75 ps-3" />
          </div>
          <div className="w-20 m-auto ms-auto d-flex">
            <FontAwesomeIcon icon={faBars} className="text-end" />
          </div>
        </div>
        <div className="text-title" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-ban1" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line2" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <br />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
      </div>

      {imageUrls.length > 0 && (
        <div
          id="swiper-rotate-circle-box"
          style={{
            width: '100%',
            height: 'auto',
            minHeight: `${swiperHeight}px`,
            position: 'relative',
            zIndex: '1501',
          }}
        >
          <Swiper
            ref={swiperRef}
            effect="cube"
            grabCursor
            speed={1000}
            cubeEffect={{
              shadow: true,
              slideShadows: true,
              shadowOffset: 20,
              shadowScale: 0.94,
            }}
            modules={[EffectCube]}
            slidesPerView={1}
            loop
            observer
            observeParents
            className="swiper-cube"
            style={{
              width: '100%',
              height: 'auto',
              position: 'relative',
            }}
          >
            {imageUrls.map((image, index) => (
              <SwiperSlide key={index}>
                <img
                  src={image}
                  alt={`Slide ${index}`}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                />
                <CIIcon />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      )}

      {/* 底部內容 */}
      <div style={{ position: 'relative', paddingTop: '1rem' }}>
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <br />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
      </div>
    </div>
  )
}

RotateCubeStickyPreview.propTypes = {
  srcs: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(File),
        PropTypes.instanceOf(Blob),
      ]),
    })
  ).isRequired,
}

export default RotateCubeStickyPreview
